import type { CMSConfig } from '#types/config/components/cms'

export default {
  size: {
    sm: { size: 'sm' },
    lg: { size: 'md' }
  }
} satisfies CMSConfig['sharedButton']
